<template>
  <v-col>
    <validation-provider v-slot="{ errors }" :rules="rules" :name="name">
      <v-autocomplete
        :items="theTerminais"
        :error-messages="errors"
        :value="value"
        :label="label"
        :prepend-icon="icon"
        :search-input.sync="search"
        item-text="trade_name"
        item-value="public_id"
        @input="$emit('input', $event)"
        no-filter
        @keyup="customChange($event, handleGetTerminais)"
        :loading="calling"
      >
        <template v-slot:item="{ item }">
          <v-list-item-content>
            <v-list-item-title v-text="item.trade_name"></v-list-item-title>
            <v-list-item-subtitle
              v-text="`CNPJ ${item.cnpj} - ${item.city} - ${item.district}`"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </v-autocomplete>
    </validation-provider>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import ContratosApi from '@/services/tenants/contratos'
import { customChange } from '@/mixins/autocomplete.js'
import  Perfil from '@/utils/perfil'

export default {
  name: 'GerenciamentoServicoListFiltroModalIntemInputTerminal',
  mixins: [customChange],
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    rules: {
      type: [Object, String],
    },
    value: {
      required: true,
    },
  },
  data() {
    return {
      search: '',
      terminaisSelecionados: [],
    }
  },
  computed: {
    ...mapState('auth', ['empresaAtual', 'user']),
    theTerminais(){
      // if(this.value){
      //   return [this.value].concat(this.terminaisSelecionados.filter(c => this.value.public_id != c.public_id))
      // }
      return this.terminaisSelecionados
    }
  },
  methods: {
    async handleGetTerminais(event) {
      const value = event.target.value
      await this.getTerminalSearch({
        perfil: Perfil.Terminal,
        pesquisa: value,
      })
    },
    async getTerminalSearch(parametros) {
      if (!Object.keys(parametros).length) return

      try {
        const terminal = await ContratosApi.getContratos(
          this.empresaAtual.public_id,
          parametros
        )

        this.terminaisSelecionados = terminal
      } catch (e) {
        console.log(e)
        if (e.response.status === 404) {
          this.errorMessage('Página não encontrada')
        }
      }
    },
  },
}
</script>
